import { render, staticRenderFns } from "./location_source_price.vue?vue&type=template&id=368f8764&scoped=true&"
import script from "./location_source_price.vue?vue&type=script&lang=js&"
export * from "./location_source_price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368f8764",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('368f8764')) {
      api.createRecord('368f8764', component.options)
    } else {
      api.reload('368f8764', component.options)
    }
    module.hot.accept("./location_source_price.vue?vue&type=template&id=368f8764&scoped=true&", function () {
      api.rerender('368f8764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/base/location_modal/tabs/location_source_price.vue"
export default component.exports